import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SearchRequestModel } from '../models/search-request-model';
import { SearchResultsModel } from '../models/search-results-model';
import { BaseService } from './base.service';
import { ConstantsService } from './constants.service';
import { SearchOutputModel } from '../models/search-output-model';
import { SuggestRequestModel } from '../models/suggest-request-model';
import { DocItemSearchModel } from '../models/doc-item-search-model';

@Injectable({
  providedIn: 'root'
})
export class PubSearchService extends BaseService {

  constructor(public override http: HttpClient,
    public override constants: ConstantsService) {
    super(http, constants, constants.api_azsearch);
  }
  
  getSearchResultsReq(item: SearchRequestModel): Observable<SearchOutputModel> {
    return this.http.post<SearchOutputModel>(this.api + environment.api_code, item)
      .pipe(catchError(this.handleError));
  }

  getSearchResultsforFolder(item: SearchRequestModel): Observable<SearchOutputModel> {
    return this.http.post<SearchOutputModel>(this.constants.api_azsearch_folder + environment.api_code, item)
      .pipe(catchError(this.handleError));
  }

  getSearchResultsReqMdOnly(item: SearchRequestModel): Observable<SearchOutputModel> {
    return this.http.post<SearchOutputModel>(this.api + environment.api_code, item)
      .pipe(catchError(this.handleError));
  }

  getDocDetails(item: DocItemSearchModel): Observable<SearchResultsModel> {
    return this.http.post<SearchResultsModel>(this.constants.api_azsearch_document + "/" + item.id + environment.api_code, item)
      .pipe(catchError(this.handleError));
  }

  getSuggestions(query: SuggestRequestModel): Observable<string[]> {
    return this.http.post<string[]>(this.constants.api_azsearch_suggest + environment.api_code, query)
      .pipe(catchError(this.handleError));
  }

  getFacetSuggestions(query: SuggestRequestModel): Observable<string[]> {
    return this.http.post<string[]>(this.constants.api_azsearch_suggest_facet + environment.api_code, query)
      .pipe(catchError(this.handleError));
  }

  downloadItems(item: SearchRequestModel): Observable<SearchOutputModel> {
    return this.http.post<SearchOutputModel>(this.constants.api_azsearch_download + environment.api_code, item)
    .pipe(catchError(this.handleError));
  }
}
